import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droit familial </h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet GAVA-<i>Lex</i> vous conseillera et vous défendra dans tous les dossiers de droit
					familial et ce, de la <strong>séparation</strong> à la liquidation du régime matrimonial.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Une séparation est toujours une période difficile à vivre d'un point de vue humain. Le cabinet vous
					assistera tout au long de la procédure afin que vous puissiez vivre ces évènements de manière plus
					sereine, tout en recherchant une solution qui puisse vous convenir.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Ainsi, le cabinet vous conseillera notamment au niveau de la procédure à intenter (
					<strong>divorce</strong> pour désunion irrémédiable ou divorce par consentement mutuel, etc...).
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si vous avez des <strong>enfants</strong>, il conviendra également de fixer les modalités
					d'hébergement de ceux-ci en tenant compte des spécificités de chaque situation.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet vous conseillera également sur les conséquences financières d'une séparation (
					<strong>secours alimentaires</strong> entre époux, <strong>part contributive</strong> pour les
					enfants, <strong>pension alimentaire</strong> après divorce, etc...).
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Enfin, le cabinet vous accompagnera lors de la liquidation du régime matrimonial (
					<strong>partage des biens</strong>, vente de l'immeuble, etc...).
				</p>
				<div className='organigation-text w-[64%] col:float-none  col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Divorce
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Hébergement des enfants
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Pension alimentaire et part contributive
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Liquidation du régime matrimonial, partage des biens
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
